<template>
  <div class="selected-odp" id="selectedOdpPreview">
    <div class="calculator-final">
      <div class="calculator-final__number selected-odp__number" style="position: relative;">
        <div id="ymapsSetOdpPreview" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0;"></div>
      </div>
<!--      <div class="calculator-final__info selected-odp__info">-->
<!--        <span class="selected-odp__subtitle">Отделение для отправки:</span>-->
<!--        <span class="selected-odp__title">«{{odpPoint.title}}»</span>-->
<!--        <div class="map-card__info-item">-->
<!--          <p class="map-card__info-title">Адрес</p>-->
<!--          <p class="map-card__info-text">{{odpPoint.address}}-->
<!--            <a class="map-card__info-link" @click="(e) => {buildRoute(e, odpPoint)}">-->
<!--              Построить маршрут сюда-->
<!--            </a>-->
<!--          </p>-->
<!--          <div class="map-card__phone">{{odpPoint.phone}}</div>-->
<!--          <p></p>-->
<!--        </div>-->
<!--        <div class="map-card__info-item">-->
<!--          <p class="map-card__info-title">Время работы</p>-->
<!--          <p class="map-card__info-text">{{odpPoint.scheduleShort}}</p>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import loadYmaps from '../../helpers/ymaps-loader';

let myMap = null;
// eslint-disable-next-line
  const imageActive = {
  iconLayout: 'default#image',
  iconImageHref: 'data:image/png;base64,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',
  iconImageSize: [42, 56],
  iconImageOffset: [-21, -56],
};

export default {
  name: 'CalculatorSelectedOdp',
  data() {
    return {
      odp: '',
      pointCollection: {},
      odpPoint: {},
      userPosition: [],
    };
  },
  props: {
    point: Object,
  },
  methods: {
    createMapPreview() {
      const self = this;
      loadYmaps().then(() => {
        // eslint-disable-next-line
        ymaps.ready(() => {
          const odp = self.odpPoint;
          // eslint-disable-next-line
          myMap = new ymaps.Map('ymapsSetOdpPreview', {
            controls: ['zoomControl'],
            center: [odp.geo.latitude, odp.geo.longitude],
            zoom: 18,
          }, {
            maxZoom: 18,
          });
          // eslint-disable-next-line
          const point = new ymaps.GeoObject({
            geometry: {
              type: 'Point',
              coordinates: [odp.geo.latitude, odp.geo.longitude],
            },
          }, imageActive);
          point.odp = self.odpPoint.id;
          myMap.geoObjects.add(point);
        });
      });
    },
    buildRoute(e, odp) {
      e.preventDefault();
      // Берем и узнаем положение пользователя, если мы его не узнаем, все тлен.
      this.getUserLocation(odp);
    },
    getUserLocation(odp) {
      // eslint-disable-next-line
        const self = this,
        // eslint-disable-next-line
          location = ymaps.geolocation.get();

      // Асинхронная обработка ответа.
      location.then(
        (result) => {
          self.userPosition = result.geoObjects.position;
          // Добавление местоположения на карту.
          myMap.geoObjects.add(result.geoObjects);
          // Вызов отрисовки, ToDo:надо еще обработать отказ определения положения
          self.routeBuild(odp);
        },
        (err) => {
          console.log(`Ошибка: ${err}`);
        },
      );
    },
    routeBuild(odp) {
      // eslint-disable-next-line
        let multiRoute = new ymaps.multiRouter.MultiRoute({
        referencePoints: [
          [this.userPosition[0], this.userPosition[1]],
          [odp.geo.latitude, odp.geo.longitude],
        ],
      }, {
        boundsAutoApply: true,
      });
      myMap.geoObjects.add(multiRoute);
    },
  },
  watch: {
    point: {
      handler() {
        if (myMap) {
          myMap.destroy();
          myMap = null;
          this.createMapPreview();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.createMapPreview();
    this.odp = this.point.id;
    this.odpPoint = this.point;
  },
};
</script>

<style lang="scss" scoped>

  .selected-odp__subtitle,
  .selected-odp__title {
    white-space: normal;
  }

  .calculator-final__number {
    width: 100%;
    flex: 0 0 100%;
  }
</style>

<style lang="scss">
  #ymapsSetOdpPreview {

    >ymaps, >.ymaps-2-1-77-map {
      width: 100% !important;
    }
  }
</style>
